import axios from "axios";
import Config from "./config";
import authHeader from "./authHeader";

const candidateDetails = () => {
  return axios.get(Config.API_URL + `api/v1/candidates/candidate-basic-info/`, {
    headers: authHeader(),
  });
};
const updatecandidaetDetails = (data, id) => {
  return axios.patch(
    Config.API_URL + `api/v1/candidates/candidate-basic-info/${id}/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const candidateContactDetails = () => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/myprofile-personal-info/`,
    {
      headers: authHeader(),
    }
  );
};
const updateContactDetails = (data, id) => {
  return axios.patch(
    Config.API_URL + `api/v1/candidates/myprofile-personal-info/${id}/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const getResumeDetails = () => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/myprofile-resume-view/`,
    {
      headers: authHeader(),
    }
  );
};

const getMultiResumeDetails = () => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/candidates-resumes-upload/`,
    {
      headers: authHeader(),
    }
  );
};

const updateResumeDetails = (id, data) => {
  return axios.patch(
    Config.API_URL + `api/v1/candidates/candidates-resumes-upload/${id}/`,
    data,
    {
      headers: authHeader(),
    }
  );
};

const removeResume = (id) => {
  return axios.delete(
    Config.API_URL + `api/v1/candidates/candidates-resumes-upload/${id}/`,
    {
      headers: authHeader(),
    }
  );
};

const getExperienceDetails = () => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/my-profile-experience/`,
    {
      headers: authHeader(),
    }
  );
};
const getExperienceById = (id) => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/my-profile-experience/${id}`,
    {
      headers: authHeader(),
    }
  );
};
const addExperience = (data) => {
  return axios.post(
    Config.API_URL + `api/v1/candidates/my-profile-experience/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const updateExperience = (data, id) => {
  return axios.put(
    Config.API_URL + `api/v1/candidates/my-profile-experience/${id}/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const getProjectDetails = () => {
  return axios.get(Config.API_URL + `api/v1/candidates/my-profile-project/`, {
    headers: authHeader(),
  });
};
const getProjectById = (id) => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/my-profile-project/${id}`,
    {
      headers: authHeader(),
    }
  );
};
const addProject = (data) => {
  return axios.post(
    Config.API_URL + `api/v1/candidates/my-profile-project/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const updateProjects = (data, id) => {
  return axios.put(
    Config.API_URL + `api/v1/candidates/my-profile-project/${id}/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const getEducationDetails = () => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/my-profile-educations/`,
    {
      headers: authHeader(),
    }
  );
};
const getEducationById = (id) => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/my-profile-educations/${id}`,
    {
      headers: authHeader(),
    }
  );
};
const addEducation = (data) => {
  return axios.post(
    Config.API_URL + `api/v1/candidates/my-profile-educations/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const updateEducation = (data, id) => {
  return axios.put(
    Config.API_URL + `api/v1/candidates/my-profile-educations/${id}/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const getCertificationDetails = () => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/my-profile-certications/`,
    {
      headers: authHeader(),
    }
  );
};
const getCertificationById = (id) => {
  return axios.get(
    Config.API_URL + `api/v1/candidates/my-profile-certications/${id}`,
    {
      headers: authHeader(),
    }
  );
};
const addCertification = (data) => {
  return axios.post(
    Config.API_URL + `api/v1/candidates/my-profile-certications/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const updateCertification = (data, id) => {
  return axios.put(
    Config.API_URL + `api/v1/candidates/my-profile-certications/${id}/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const getCandidateSkill = () => {
  return axios.get(Config.API_URL + `api/v1/candidates/my-profile-skills/`, {
    headers: authHeader(),
  });
};
const createSkills = (skillId, deletedSkillId, newAddedSkills = []) => {
  return axios.post(
    Config.API_URL + `api/v1/candidates/my-profile-skills/`,
    {
      skills_id: skillId,
      new_skills: newAddedSkills,
      deleted_skills: deletedSkillId,
    },
    {
      headers: authHeader(),
    }
  );
};
const candidateProfileCompletion = () => {
  return axios.get(Config.API_URL + `api/v1/candidates/myprofile-completion/`, {
    headers: authHeader(),
  });
};
const getAboutMeDetails = () => {
  return axios.get(Config.API_URL + `api/v1/candidates/my-profile-aboutme/`, {
    headers: authHeader(),
  });
};
const getAboutMeDetailsById = (id) => {
  return axios.get(Config.API_URL + `api/v1/candidates/my-profile-aboutme/`, {
    headers: authHeader(),
  });
};
const updateCandidateDetails = (data, id) => {
  return axios.put(
    Config.API_URL + `api/v1/candidates/my-profile-aboutme/${id}/`,
    data,
    {
      headers: authHeader(),
    }
  );
};
const getRecordedDetails = () => {
  return axios.get(Config.API_URL + `api/v1/candidates/my-profile-video/`, {
    headers: authHeader(),
  });
};
const upadeProfileVideo = (blob, id) => {
  const videoFile = new File([blob], "video/webm", {
    type: "video/webm",
    codecs: "vp8",
  });
  const formData = new FormData();
  formData.append("profile_video", videoFile);
  return axios.put(
    Config.API_URL + `api/v1/candidates/my-profile-video/${id}/`,
    formData,
    {
      headers: authHeader(),
    }
  );
};
const getProfilePicture = () => {
  return axios.get(Config.API_URL + `api/v1/candidates/my-profile-picture/`, {
    headers: authHeader(),
  });
};
const updateProfilePicture = (fileName, id) => {
  const formData = new FormData();
  formData.append("profile_picture", fileName);
  return axios.put(
    Config.API_URL + `api/v1/candidates/my-profile-picture/${id}/`,
    formData,
    {
      headers: authHeader(),
    }
  );
};
const uploadDocument = (data, documentName, jobId, params) => {
  const formData = new FormData();
  formData.append("document_type", data.document_type.value);
  formData.append("document", data.document);
  formData.append("candidate", jobId);
  return axios.post(
    Config.API_URL + `api/v1/candidates/my-profile-documents/`,
    formData,
    {
      params,
      headers: authHeader(),
    }
  );
};
const getDocuments = (jobId = null, candidateId = null) => {
  const params = {};
  if (jobId != null) {
    params["job_id"] = jobId;
  }
  if (candidateId != null) {
    params["candidate_id"] = candidateId;
  }
  return axios.get(Config.API_URL + `api/v1/candidates/my-profile-documents/`, {
    params,
    headers: authHeader(),
  });
};

const getDocumentTypes = (params) => {
  return axios.get(Config.API_URL + `api/v1/company/company-documents-types/`, {
    params,
    headers: authHeader(),
  });
};

const deleteDocument = (id, jobId) => {
  return axios.delete(
    Config.API_URL +
      `api/v1/candidates/my-profile-documents/${id}/?job_id=${jobId}`,
    {
      headers: authHeader(),
    }
  );
};

const deleteChosenDocument = (id, params) => {
  return axios.delete(
    Config.API_URL + `api/v1/candidates/my-profile-documents/${id}/`,
    {
      params,
      headers: authHeader(),
    }
  );
};
const confirmDocument = (checkedItems) => {
  return axios.put(
    Config.API_URL + `api/v1/candidates/my-profile-document-status/`,
    {
      ids: checkedItems,
      status: "CONFIRM",
    },
    {
      headers: authHeader(),
    }
  );
};
const updateReumeUpload = (file) => {
  const formData = new FormData();
  formData.append("resume", file);
  return axios.post(
    Config.API_URL + `api/v1/candidates/candidates-resumes-upload/`,
    formData,
    {
      headers: authHeader(),
    }
  );
};
const CandodateService = {
  candidateDetails,
  candidateContactDetails,
  updateContactDetails,
  getResumeDetails,
  getExperienceDetails,
  addExperience,
  updateExperience,
  getExperienceById,
  getProjectDetails,
  getProjectById,
  addProject,
  updateProjects,
  getEducationDetails,
  getEducationById,
  addEducation,
  updateEducation,
  getCertificationDetails,
  getCertificationById,
  addCertification,
  updateCertification,
  getCandidateSkill,
  createSkills,
  candidateProfileCompletion,
  getAboutMeDetails,
  updatecandidaetDetails,
  getAboutMeDetailsById,
  updateCandidateDetails,
  getRecordedDetails,
  upadeProfileVideo,
  getProfilePicture,
  updateProfilePicture,
  getDocuments,
  getDocumentTypes,
  uploadDocument,
  deleteDocument,
  deleteChosenDocument,
  confirmDocument,
  getMultiResumeDetails,
  updateResumeDetails,
  removeResume,
  updateReumeUpload,
};
export default CandodateService;
